import {
    Box,
    Grid
} from '@mui/material';
import HeaderBreadcrumb from '../shared-components/HeaderBreadcrumb';
import { CategorySelection, CompanySelection, ConversionFactorSelection, YearSelection } from '../shared-components/SelectionButtons';
import SpendBasedConversionFactors from './spend-based-conversion-factors/SpendBasedConversionFactors';
import EmissionFactors from './emission-factors/EmissionFactors';
import useButtonSelection from '../hooks/button-selection-hooks';

export default function ConversionFactors({ variant, company, years, groups }) {
    const {
        selectedYear,
        selectedCompany,
        categories,
        selectedCategory,
        selectedConversionFactor,
        handleOnClick } = useButtonSelection(variant, company, years, groups)

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <HeaderBreadcrumb variant={variant} year={selectedYear} company={selectedCompany} category={selectedCategory}
                conversionFactor={selectedConversionFactor} />
            <Grid container item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2 }}>
                <YearSelection years={years} selectedYear={selectedYear} handleOnClick={handleOnClick} />
                {selectedYear &&
                    <CompanySelection company={company} selectedCompany={selectedCompany} handleOnClick={handleOnClick} />}
                {selectedCompany &&
                    <ConversionFactorSelection selectedConversionFactor={selectedConversionFactor} handleOnClick={handleOnClick} />}
                {selectedConversionFactor === 'Emission Factors' &&
                    <CategorySelection categories={categories} selectedCategory={selectedCategory} handleOnClick={handleOnClick} />}
            </Grid>
            {
                selectedConversionFactor === 'Spend-Based Conversion Factors' &&
                <SpendBasedConversionFactors
                    year={selectedYear}
                    company={selectedCompany}
                    conversionFactor={selectedConversionFactor} />
            }
            {
                selectedCategory && selectedConversionFactor === 'Emission Factors' &&
                <EmissionFactors
                    year={selectedYear}
                    company={selectedCompany}
                    category={selectedCategory}
                    conversionFactor={selectedConversionFactor} />
            }
        </Box>
    )
}